import { Capacitor } from "@capacitor/core";

export const platform = Capacitor.getPlatform() as "web" | "ios" | "android";
export const isNative = Capacitor.isNativePlatform();

export async function openExternal(url: string): Promise<void> {
  if (url.startsWith("tel:")) {
    window.location.href = url; // the phone's dialer (Android hands tel: links to it)
    return;
  }
  if (isNative) {
    const { Browser } = await import("@capacitor/browser");
    await Browser.open({ url });
  } else {
    window.open(url, "_blank", "noopener");
  }
}

export async function shareLink(data: { title?: string; text?: string; url?: string }): Promise<boolean> {
  if (isNative) {
    const { Share } = await import("@capacitor/share");
    await Share.share(data);
    return true;
  }
  if (navigator.share) {
    try {
      await navigator.share(data);
      return true;
    } catch {
      return false; // user cancelled
    }
  }
  await navigator.clipboard.writeText(data.url ?? data.text ?? "");
  return false; // copied instead
}
